export const PROJECT_SHEET_EVENTS = {
  INVALIDATE: "PROJECT_SHEET_INVALIDATE",
};

const projectSheetEventBus = new EventTarget();

export function emitProjectSheetInvalidation() {
  projectSheetEventBus.dispatchEvent(
    new Event(PROJECT_SHEET_EVENTS.INVALIDATE)
  );
}

export function onProjectSheetInvalidation(callback) {
  projectSheetEventBus.addEventListener(
    PROJECT_SHEET_EVENTS.INVALIDATE,
    callback
  );

  return () => {
    projectSheetEventBus.removeEventListener(
      PROJECT_SHEET_EVENTS.INVALIDATE,
      callback
    );
  };
}
